export function getReactSelectStyleClasses() {
    return {
        container: () => "select-container",
        control: (state) => (state.isFocused ? "select-control-focus" : "select-control"),
        indicatorSeparator: () => "select-indicator-separator",
        indicatorsContainer: () => "select-indicator-container",
        valueContainer: () => "select-value-container",
        menu: () => "select-menu",
        menuPortal: () => "select-menu-portal",
        menuList: () => "select-menu-list",
        option: (state) => (state.isSelected ? "select-option-selected" : state.isFocused ? "select-option-focus" : "select-option"),
        singleValue: () => "select-single-value"
    };
}
